export class VagliaBdiDTO {
  meMedesimo: boolean;
  studioLegale: boolean;
}
